import _ from 'lodash'
import DataSourceInfoWizard from 'scoreboard/imports/data-source-info-wizard'
import UploadSpreadsheet from 'scoreboard/imports/upload-spreadsheet'
import WorksheetOptions from 'scoreboard/imports/worksheet-options'
import NewColumnNameChooser from 'scoreboard/imports/new-column-name-chooser'

const UploadSpreadsheetWizard = DataSourceInfoWizard.extend({

	/**
	 * Wizard for uploading a new spreadsheet for an import
	 *
	 * @constructs
	 *
	 */
	initialize: function(options = {}) {
		this.hasMultipleSheets = false
		DataSourceInfoWizard.prototype.initialize.apply(this, arguments)
	},

	getViews:  function() {
		let views = [ UploadSpreadsheet ]
		if (this.hasMultipleSheets) {
			views.push(WorksheetOptions)
		}
		if (!_.isNil(this.newColumnChooserIndex)) {
			views.splice(this.newColumnChooserIndex, 0, NewColumnNameChooser)
		}
		return views
	},

	setHasMultipleSheets: function(hasMultipleSheets) {
		this.hasMultipleSheets = hasMultipleSheets
		this.setViews(this.getViews())
		this.render(this.options)
	},

	finish: function(model) {
		this.model = model
		this.model.unset('newColumnNames')
		this.trigger('done', this.model)
	}
})

export default UploadSpreadsheetWizard
UploadSpreadsheetWizard.__filename__ = 'imports/upload-spreadsheet-wizard.js'
